
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CardHead extends Vue {
  @Prop({ default: "Title Here" }) readonly title!: string;
  @Prop({ default: "Content" }) readonly content!: string;
}
